import React from "react";
import { Link } from "react-router-dom";
import "./statusPages.css";

const FailurePage = () => {
  return (
    <div className="status-container failure-bg">
      <div className="status-card">
        <div className="status-icon failure-icon">✕</div>

        <h1>Payment Failed</h1>

        <p>
          Unfortunately, your payment could not be processed. Please try again
          or use another payment method.
        </p>

        <div className="status-buttons">
          <Link to="/" className="btn btn-outline">
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FailurePage;
